import React, {Component} from 'react';
import Levels from '../../src/data';
import { connect } from "react-redux"
import { setGameOptions } from '../actions';
import {
  Link
} from 'react-router-dom'

class LevelComplete extends Component {
  componentWillUnmount(){
    const currentLevel = parseInt(this.props.match.params.level, 10);
    const setToReview = currentLevel === (this.props.unlockedLevel - 1) && this.props.unlockedLevel % 4 === 0
    console.log(setToReview);
    this.props.setGameOptions({current_word: 0, words: [], needs_review: setToReview ? true : false})
  }
	render(){
    const { needsReview, unlockedLevel } = this.props;
    const completedLevelNum = parseInt(this.props.match.params.level, 10);
    const isReviewLevel = needsReview && completedLevelNum === unlockedLevel;
    const completedLevel = Levels[completedLevelNum];
    
    const koreanLevelTitle = isReviewLevel ? [Levels[completedLevelNum - 1].korean,
                Levels[completedLevelNum - 2].korean,
                Levels[completedLevelNum - 3].korean,
                Levels[completedLevelNum - 4].korean] : completedLevel.korean;
		const nextLevel = Levels[completedLevelNum + 1];
		const wordList = this.props.words.map((val, key) => {
			return (
        <li key={key}>
          <span>{val.korword}</span>
          <span>{val.engword}</span>
          {val.unlock !== undefined && !isReviewLevel ? <div className="unlocked-indicator"><span>{nextLevel.korean} Unlocked!</span></div> : ""}
        </li>
			)
    });
		return (
			<div>
				<div className="game-header game-complete">
					<span className="game-header-title">Level Summary</span>
					<div className="display-korean">{
            isReviewLevel ?
              koreanLevelTitle.map((val) => <div>{val}</div>)
            :
              <span>{koreanLevelTitle}</span>
            }</div>
					<span className="game-header-title">{!isReviewLevel ? completedLevel.english : ''}</span>
				</div>
				<div className="game-body">
				 <ul className="word-list">
					{wordList}
					</ul>
					<Link to={"/menu/"}><button>Continue</button></Link>
				</div>
			</div>

		)
	}
}

const mapStateToProps = ({ GameOptions }) => {
  return {
		needsReview: GameOptions.needs_review,
    words: GameOptions.words,
    unlockedLevel: GameOptions.unlocked_level
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGameOptions: GameOptions => {
      dispatch(setGameOptions(GameOptions));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LevelComplete);



// WEBPACK FOOTER //
// ./src/components/levelcomplete.js